import React, { Component, Fragment } from 'react'
import './BillingCyclePopup.scss'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import { isEmpty, includes, isEqual, round, orderBy, toLower } from 'lodash'
import { codeDiscountFromAffiliate, revertCodeSubscribe } from 'utils/utils'
import {  HUNDRED_PERCENT, PERCENT_DISCOUNT } from 'config/constants'
import loadable from '@loadable/component'
import axios from 'axios'
import { getSubscriptionCycleTime, daysBetweenTwoDate } from 'services/subscription_services'

const ContactPopup = loadable(() => import('./ContactPopup/ContactPopup'))
const CheckInfoPopup = loadable(() => import('./CheckInfoPopup/CheckInfoPopup'))

class BillingCyclePopup extends Component {
  constructor(props) {
    super(props)

    const initProductId = isEmpty(props.billingCycleOptionData) ? '' : props.billingCycleOptionData.find(option => option.id === props.planId).product_id
    
    this.state = {
      selectedOption: '3 Monthly',
      productId: initProductId,
      currentSubsPrice: 0.0,
      changeSubscriptionPopup: {
        selectedPlan: '',
        showing: false,
      },
      checkInfoPopup: {
        selectedPlan: '',
        code: '',
        showing: false,
      }
    }
    this.handleSave = this.handleSave.bind(this)
    this.handleShowContactPopup = this.handleShowContactPopup.bind(this)
    this.findPlanCondition = this.findPlanCondition.bind(this)
    this.handleShowCheckInfoPopup = this.handleShowCheckInfoPopup.bind(this)
  }

  handleChangeOptions(optionName, productId) {
    if(this.state.selectedOption === optionName) return
    this.setState({
      selectedOption: optionName,
      productId
    })
    this.props.handleUpdateSelectedSubscription(productId)
  }

  handleShowContactPopup() {
    this.setState({changeSubscriptionPopup: {...this.state.changeSubscriptionPopup, showing: !this.state.changeSubscriptionPopup.showing} })
  }

  findPlanCondition(option) {
    const { productId } = this.state
    return isEmpty(productId) ? includes(option.product_id, '3-monthly') : isEqual(option.product_id, productId)
  }

  handleShowCheckInfoPopup() {
    this.setState({checkInfoPopup: {...this.state.checkInfoPopup, showing: !this.state.checkInfoPopup.showing} })
  }

  getCurrentSubscriptionPrice(selectedPlan) {
    const { currentUser } = this.props
    const { subscription: currentSubscription, affiliate_code } = currentUser
    const { fastspring_subscription_id } = currentSubscription
    const code = isEmpty(affiliate_code) ? 'prometheus' : affiliate_code !== 'pokercode' ? affiliate_code : 'pokercode'
    // disable upgrade yearly subscription in Black Friday sale event
    if(selectedPlan.product_id.includes('yearly') && currentSubscription.plan.product_id.includes('yearly')) {
      selectedPlan = { ...selectedPlan, enableOption: false}
      this.setState({
        changeSubscriptionPopup: { selectedPlan: selectedPlan, showing: true },
      })
      return
    }
    axios.post("/subscriptions/get_subscription", { fastspring_subscription_id: fastspring_subscription_id }).then(res => {
      const { data: { data: subscription }} = res

      const { price_discount } = currentSubscription
      const oldSubsPrice = round(subscription.subtotal) || price_discount

      const currentTime = new Date()
      //Calculate current Subscription data
      const currentSubscriptionStartTime = new Date(currentSubscription.start_time)
      const currentSubscriptionRenewTime = new Date(currentSubscription.renew_time)
      const numOfDayInCurrentSubPeriod = daysBetweenTwoDate(currentSubscriptionStartTime, currentSubscriptionRenewTime)
      const utilizedDayCurrentSub = daysBetweenTwoDate(currentSubscriptionStartTime, currentTime)
      const utilizedPriceCurrentSub = oldSubsPrice * (utilizedDayCurrentSub / numOfDayInCurrentSubPeriod)    
      const priceUnUseCurrentSub = oldSubsPrice - utilizedPriceCurrentSub

      //Calculate new Subscription data
      const percent = PERCENT_DISCOUNT[code] || 0
      const newSubPrice = round(selectedPlan.price*(1 - percent), 2)
      const newSubscriptionCycleTime = getSubscriptionCycleTime(selectedPlan)
      const newSubscriptionStartTime = currentSubscriptionStartTime           //Set this because we used the prorate of FS so the start time will must be the same
      let newSubscriptionRenewTime = new Date(currentSubscription.start_time)
      newSubscriptionRenewTime = new Date(newSubscriptionRenewTime.setMonth(newSubscriptionRenewTime.getMonth() +  newSubscriptionCycleTime))
      const numOfDayInNewSubPeriod = daysBetweenTwoDate(newSubscriptionStartTime, newSubscriptionRenewTime)
      const numOfRemainDayNewSub = numOfDayInNewSubPeriod - utilizedDayCurrentSub
      const remainPriceNewSub = newSubPrice * (numOfRemainDayNewSub / numOfDayInNewSubPeriod)
      if((remainPriceNewSub - priceUnUseCurrentSub) < 0) {
        selectedPlan = { ...selectedPlan, enableOption: false}
      }

      this.setState({
        changeSubscriptionPopup: { selectedPlan: selectedPlan, showing: true },
        currentSubsPrice: oldSubsPrice || 0.0
      })
    })
  }

  handleSave() {
    const { billingCycleOptionData, currentUser, isChangeSubscriptionView } = this.props
    const { email, affiliate_code } = currentUser    
    const selectedPlan = billingCycleOptionData.find(option => this.findPlanCondition(option))
    const pathname = window.location.pathname
    const code = isEmpty(currentUser) ? revertCodeSubscribe(toLower(pathname)) : isEmpty(affiliate_code) ? 'prometheus' : affiliate_code
    if(isChangeSubscriptionView) {
      if(selectedPlan.enableOption) {
        this.getCurrentSubscriptionPrice(selectedPlan) // for Black Friday sale event, should remove later
        this.props.showBillingCyclePopup()
      } else {
        this.setState({ changeSubscriptionPopup: { selectedPlan: selectedPlan, showing: true } })
      }
    } else {
      if(isEmpty(currentUser)) {
        this.setState({ checkInfoPopup: { selectedPlan: selectedPlan, code: code, showing: true } })
      }
      else {
        window.fastspring.builder.reset()    // ensure empty cart
        window.fastspring.builder.add(selectedPlan.product_id)
        window.fastspring.builder.tag({ 'user_email': email })
        window.fastspring.builder.promo(codeDiscountFromAffiliate(code))
        window.fastspring.builder.checkout()
      }
      this.props.showBillingCyclePopup()
    }
  }

  nameOfPlans(productId, parentCode) {
    switch(productId) {
      case `${parentCode}`:
        return 'Month'
      case `${parentCode}-3-monthly`:
        return '3 Monthly'
      default:
        return 'Yearly'
    }
  }

  saleValue(product, parentCode) {
    switch(product.product_id) {
      case `${parentCode}`:
        return ''
      case `${parentCode}-3-monthly`:
        return 'save 10%'
      default:
        return 'save 25%'
    }
  }

  priceOfPlan(productId, parentCode, price) {
    const { currentUser } = this.props
    const { affiliate_code } = currentUser
    const pathname = window.location.pathname
    const isNotSignIn = isEmpty(currentUser)
    const code = isNotSignIn ? revertCodeSubscribe(toLower(pathname)) : isEmpty(affiliate_code) ? 'prometheus' : affiliate_code
    const percentDiscount = PERCENT_DISCOUNT[code] || 0

    const pricePerMonth = price * (HUNDRED_PERCENT - percentDiscount)

    switch(productId) {
      case `${parentCode}`:
        return `$${round(pricePerMonth)}/month`
      case `${parentCode}-3-monthly`:
        return `$${round(pricePerMonth/3)}/month`
      default:
        return `$${round(pricePerMonth/12)}/month`
    }
  }

  onClosePopup = () => {
    this.setState({ selectedOption: '3 Monthly' })
    this.props.showBillingCyclePopup()
  }

  newPrice(product) {
    switch(product.product_id) {
      case 'cash-mtts':
        return {...product, newPrice: 194};
      case 'cash':
        return {...product, newPrice: 99};
      case 'mtts':
        return {...product, newPrice: 161};
      case 'cash-mtts-3-monthly':
        return {...product, newPrice: 499};
      case 'cash-3-monthly':
        return {...product, newPrice: 255};
      case 'mtts-3-monthly':
        return {...product, newPrice: 390};
      case 'cash-mtts-yearly':
        return {...product, newPrice: 1499};
      case 'cash-yearly':
        return {...product, newPrice: 924};
      case 'mtts-yearly':
        return {...product, newPrice: 1320};
      default:
        return {...product, newPrice: product.price};
    }
  }

  blackFridayPrice(products) {
    let newProducts = products.map(product => {
      return this.newPrice(product)
    });
    return newProducts
  }

  render() {
    const t = this.context.t
    const { show, billingCycleOptionData, handleConfirmedChangeSub } = this.props
    const { selectedOption, changeSubscriptionPopup: {showing: showChangeSubscriptionPopup, selectedPlan: changePlan},
      checkInfoPopup: {showing: showCheckInfoPopup, code: checkoutCode, selectedPlan} } = this.state
    let data = orderBy(billingCycleOptionData.filter(op => op.product_id !== 'wsop-ultimate'), 'id')

    return (
      <Fragment>
        <Modal
        show={show}
        onHide={this.onClosePopup}
        dialogClassName='subscribe-billing-cycle-options-modal'
        backdrop="static"
        aria-labelledby='subscribe-billing-cycle-options-modal'
        >
          <Modal.Body bsPrefix='custom-modal-body'>
            <Modal.Header bsPrefix='custom-modal-header d-flex justify-content-between align-items-center' closeButton>
              <Modal.Title id="options-modal"> {t('subscribe.popup_title')} </Modal.Title>
            </Modal.Header>
            <div className='content pt-2 pb-0 px-0'>
            {
              data.map( option => {
                const { price, parent_code, product_id, id} = option
                const name = this.nameOfPlans(product_id, parent_code)
                const saleValue = this.saleValue(option, parent_code)
                const priceItem = this.priceOfPlan(product_id, parent_code, price)
                const isSelectedOptions = name === selectedOption
                const saleOptionElement = isSelectedOptions ? <span className='option-sale'> {saleValue} </span> 
                                                            : <span className='option-sale-inactive'> ({saleValue}) </span>
                return (
                  <div className={`option d-flex justify-content-between align-items-center ${isSelectedOptions && 'active'}`} key={id}  onClick={() => this.handleChangeOptions(name, product_id)}>
                    <span> {name} {saleValue && saleOptionElement } </span>
                    <div className='option-price'> {priceItem} </div>
                  </div>
                )
              })
            }
            </div>
            <button className='btn subscribe-now-btn' onClick={this.handleSave}>
              {t('subscribe.button')}
            </button>
          </Modal.Body>
        </Modal>
        {showChangeSubscriptionPopup &&
          <ContactPopup 
            show={showChangeSubscriptionPopup}
            selectedPlan={changePlan}
            handleShowContactPopup={this.handleShowContactPopup}
            handleConfirmedChangeSub={handleConfirmedChangeSub}
            currentSubsPrice={this.state.currentSubsPrice}
          />
        }
        <CheckInfoPopup
          show={showCheckInfoPopup}
          selectedPlan={selectedPlan}
          code={checkoutCode}
          handleShowCheckInfoPopup={this.handleShowCheckInfoPopup}
        />
      </Fragment>
    )
  }
}

BillingCyclePopup.contextTypes = {
  t: PropTypes.func
}

const mapStoreToProps = (store) => ({
  subscriptions: store.subscriptions,
  currentUser: store.reduxTokenAuth.currentUser.attributes,
})

export default connect(
  mapStoreToProps,
  null
)(BillingCyclePopup)
